import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=15fef06e&scoped=true&lang=pug"
import script from "./brief.vue?vue&type=script&lang=js"
export * from "./brief.vue?vue&type=script&lang=js"
import style0 from "./brief.vue?vue&type=style&index=0&id=15fef06e&prod&lang=scss&scoped=true"
import style1 from "./brief.vue?vue&type=style&index=1&id=15fef06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fef06e",
  null
  
)

export default component.exports